"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentryReduxEnhancer = void 0;
exports.initSentry = initSentry;
const Sentry = __importStar(require("@sentry/react"));
const tracing_1 = require("@sentry/tracing");
const SentryFilters_1 = require("./SentryFilters");
const Log = __importStar(require("./Log"));
function initSentry(isEnabled, sentryDSN, environment, release, ignoreErrors = undefined, initBrowserTracing, tracesSampleRate, sensitiveFields) {
    if (isEnabled === true) {
        const integrations = [];
        // This enables automatic instrumentation
        // https://docs.sentry.io/platforms/javascript/guides/react/performance/
        if (initBrowserTracing) {
            integrations.push(new tracing_1.BrowserTracing());
        }
        ;
        try {
            Sentry.init(Object.assign(Object.assign({ dsn: sentryDSN !== null ? sentryDSN : undefined, environment: environment !== null ? environment : undefined, release: release !== null ? release : undefined, ignoreErrors: ignoreErrors, normalizeDepth: 10 }, integrations.length ? {
                integrations,
            } : {}), { 
                // To set a uniform sample rate
                tracesSampleRate, beforeSend: (event, hint) => {
                    return (0, SentryFilters_1.beforeSend)({ event, hint, sensitiveFields });
                } }));
        }
        catch (error) {
            Log.error("Could not initialise Sentry.", { originalException: error });
        }
    }
}
const sentryReduxEnhancer = ({ actionTransformer, stateTransformer, configureScopeWithState }) => Sentry.createReduxEnhancer({
    /**
     * Transforms the action before sending it as a breadcrumb.
     * Use this to remove any private data before sending it to Sentry.
     * Return null to not send the breadcrumb.
     */
    actionTransformer,
    /**
     * Called on every state update, configure the Sentry Scope with the redux state.
     */
    configureScopeWithState,
    /**
     * Transforms the state before attaching it to an event.
     * Use this to remove any private data before sending it to Sentry.
     * Return null to not attach the state.
     */
    stateTransformer,
});
exports.sentryReduxEnhancer = sentryReduxEnhancer;
//# sourceMappingURL=StartupHelpers.js.map